<template>
  <button
    v-bind="$attrs"
    data-inheritattrs
    class="nortic-button"
    :class="classes"
    @click="emitClickEvent"
    @mouseover="hovered = true"
    @mouseleave="hovered = false"
  >
    <SvgIcon
      v-if="icon"
      :data="icon"
      class="icon"
      height="1em"
      width="1em"
    />
    <slot />
  </button>
</template>

<script>
import colorHandler from '@/mixins/themeSupport';
import button from '@/components/common/button/mixin/button';

export default {
  name: 'NorticButton',
  mixins: [colorHandler(), button],
  inheritAttrs: false,
  props: {
    icon: {
      type: [String, Object],
      default: null,
    },
  },
  methods: {
    emitClickEvent(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/components/common/button/mixin/sass/button.scss';

  $multiplier: 2;

  .nortic-button {
    @include applyButtonStyles($multiplier);

    .icon {
      position: relative;
      left: -0.3em;
      margin-right: 0.3em;
      margin-left: 0.3em;
    }
  }
</style>
